export default __webpack_public_path__ + "static/media/img6.07140ec9.jpg";